import React from 'react';
import MobileSheet from 'components/MobileSheet';
import { CardSize } from 'components/CardSizeSelector/CardSizeSelector';
import { OfferSide } from '../context/OfferBuilderContext';
import OfferColumn from './OfferColumn';

interface OfferPhoneCartSheetProps {
  side: OfferSide;
  title: string;
  emptyGuidance: React.ComponentProps<typeof OfferColumn>['emptyGuidance'];
  /** The builder's row size class, re-applied inside the portal. */
  cardSize: CardSize;
  nextLabel: string;
  onClose: () => void;
  onNext: () => void;
}

/**
 * The phone cart sheet (Decision 14): the existing OfferColumn (rows, remove
 * controls, steppers, total) inside the shared MobileSheet shell, with
 * "Keep browsing" and the step's Next action.
 */
export const OfferPhoneCartSheet: React.FC<OfferPhoneCartSheetProps> = ({
  side,
  title,
  emptyGuidance,
  cardSize,
  nextLabel,
  onClose,
  onNext,
}) => (
  <MobileSheet ariaLabel="Your offer" onClose={onClose}>
    <div className={`offer-phone-cart offer-builder size-${cardSize.toLowerCase()}`} data-testid="offer-phone-cart">
      <OfferColumn side={side} title={title} emptyGuidance={emptyGuidance} />
      <div className="offer-phone-cart-actions">
        <button type="button" className="offer-phone-cart-keep" onClick={onClose}>
          Keep browsing
        </button>
        <button type="button" className="offer-phone-cart-next" onClick={onNext}>
          {nextLabel}
        </button>
      </div>
    </div>
  </MobileSheet>
);

export default OfferPhoneCartSheet;
